module.exports = function() {
      return Object.keys(this.opts.templates);
}



// WEBPACK FOOTER //
// ./~/vue-tables-2/lib/computed/templates-keys.js